import {NgModuleRef} from '@angular/core';
import {StoreModule, Store} from '@ngrx/store';

// State
import {appInitialState} from './app-initial-state';

// Interfaces
import {AppState} from './interfaces/app-state';

// This is where app state is kept between reloads
let appState: AppState = appInitialState;

export function hotModuleReplacement (bootloader: () => Promise<NgModuleRef<any>>, module: any) {

    let MODULE_REF: NgModuleRef<any>;
    let DATA = !!module.hot.data ?
        module.hot.data.state :
        undefined;

    console.log( '[HotStore] App State:', DATA );

    console.time( '[HotStore] bootstrap' );

    // Bootstrap the app, and get the resulting NgModuleRef
    if (document.readyState === 'complete') {
        bootloader()
            .then( (modRef: NgModuleRef<any>) => MODULE_REF = modRef )
            .then( () => console.timeEnd('[HotStore] bootstrap') );
    } else {
        document.addEventListener( 'DOMContentLoaded', () => {
            bootloader()
                .then( (modRef: NgModuleRef<any>) => MODULE_REF = modRef )
                .then( () => console.timeEnd('[HotStore] bootstrap') );
        });
    }

    
    function getState (store: Store<any>) {
        let state: any;
        store.take( 1 ).subscribe( s => state = s );
        return state;
    }

    
    module.hot.accept();

    /** On hot reload, get the Store from the module and store its state
    */
    module.hot.dispose( (data: any) => {

        // TODO: Create a config option to enable disable console clear
        console.clear();
        console.time( '[HotStore] dispose' );
        const store: Store<any> = MODULE_REF.injector.get( Store );
        appState = getState( store );
        (<any>Object).assign( data, {appState} );
        console.timeEnd( '[HotStore] dispose' );
    });

}

/** Factory function for an @ngrx/store NgModule that is (maybe) initialized with the state from before a hot load. */
export function provideHotStore (reducer: any) {
    return StoreModule.provideStore( reducer, appState );
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/shared/state/hot-store.ts